import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["href", "title"];
const _hoisted_2 = {
    class: "col-10 p-0 text-left",
    style: { "hyphens": "auto" }
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuItems',
    setup(__props) {
        const currentUrlPath = computed(() => {
            return location.pathname;
        });
        const RegularMenuEntries = [
            { name: 'VERKAUFEN', link: '/verkaufen', active: currentUrlPath.value === '/verkaufen' },
            { name: 'KAUFEN', link: '/kaufen', active: currentUrlPath.value === '/kaufen' },
            { name: 'STORES', link: '/stores', active: currentUrlPath.value === '/stores' },
            { name: 'HILFE', link: '/hilfe', active: currentUrlPath.value === '/hilfe' },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, _renderList(RegularMenuEntries, (e, i) => {
                return _createElementVNode("li", {
                    key: i,
                    class: _normalizeClass(["col-12 py-2", { active: e.active }])
                }, [
                    _createElementVNode("a", {
                        class: "row",
                        href: e.link,
                        title: e.name
                    }, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(e.name), 1)
                    ], 8, _hoisted_1)
                ], 2);
            }), 64));
        };
    }
});
